module.exports = __webpack_public_path__ + "static/media/logoW.c469a1a1.png";